// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  Label,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  InputCpfCnpj,
} from '../../containers/componentsInjection';
import { ModalProposals } from './components/ModalProposals';
import { CardAssociates } from './components/CardAssociates';

export const ProposalsCardPrintingPage = ({
  api,
  show,
  isOpen,
  toggle,
  search,
  history,
  setSearch,
  validation,
  associates,
  customerSelected,
  setCustomerSelected,
  handleGenerateReport,
  handleCardDependent,
}) => {
  return (
    <PageWrapper title="Impressão de Cartão">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="sellerInput" className="form-label">
                        CPF
                      </Label>
                      <InputCpfCnpj
                        id="cpfInput"
                        name="cpfInput"
                        isCPF
                        value={validation.values.cpfInput || ''}
                        onBlur={(e) => {
                          validation.handleBlur(e);
                        }}
                        onChange={(e, type) => {
                          if (type === 'CPF') {
                            const { value } = e.target;
                            setSearch({
                              ...search,
                              [e.target.name]: value,
                            });
                            validation.handleChange(e);
                          }
                        }}
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="proposal" className="form-label">
                        Proposta
                      </Label>
                      <Input
                        type="text"
                        id="proposal"
                        name="proposal"
                        className="form-control"
                        placeholder="N° da Proposta"
                        onBlur={validation.handleBlur}
                        value={validation.values.proposal}
                        onChange={(e) => {
                          const { value } = e.target;
                          setSearch({
                            ...search,
                            [e.target.name]: value,
                          });
                          validation.handleChange(e);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link me-3"
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Procurar
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
          <Row className="mt-3">
            {show &&
              (associates || []).map((item, index) => (
                <Col key={index} md={4}>
                  <CardAssociates
                    item={item}
                    setCustomerSelected={setCustomerSelected}
                    toggle={toggle}
                  />
                </Col>
              ))}
          </Row>
        </Col>
      </Row>

      <ModalProposals
        api={api}
        isOpen={isOpen}
        customer={customerSelected}
        toggle={toggle}
        handleCardDependent={handleCardDependent}
        handleGenerateReport={handleGenerateReport}
      />
    </PageWrapper>
  );
};
